"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _UITable = _interopRequireDefault(require("UIComponents/table/UITable"));

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var _MerchandiseSelectors = require("pricing-pages-unified-ui/selectors/MerchandiseSelectors");

var _ExampleSubtext = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/contacts-price-breakdown/ExampleSubtext"));

var _EmailSendsLimit = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/contacts-price-breakdown/EmailSendsLimit"));

var _ContactsSelectors = require("pricing-pages-unified-ui/selectors/ContactsSelectors");

var _SubtextMC = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/contacts-price-breakdown/SubtextMC"));

var PriceTiers = function PriceTiers(_ref) {
  var currencyCode = _ref.currencyCode,
      merchandiseId = _ref.merchandiseId,
      edition = _ref.edition,
      marketingContactsSelected = _ref.marketingContactsSelected,
      termId = _ref.termId;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var baseMarketingMerch = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.baseMerchForAdditionalUnitSelector)(state, merchandiseId);
  });
  var includedAdditionalUnits = baseMarketingMerch.includedAdditionalUnits;
  var contactQuantityMuliplier = merchandiseMap[merchandiseId].quantityMultiplier;
  var isMarketingContactsSku = (0, _reactRedux.useSelector)(function (state) {
    return (0, _MerchandiseSelectors.isMarketingContactsSKUSelector)(state, merchandiseId);
  });
  var priceTiers = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PricingSelectors.contactTierPriceMapSelector)(state, merchandiseId, termId);
  });
  var emailSendsMultiplier = (0, _reactRedux.useSelector)(function (state) {
    return (0, _ContactsSelectors.emailSendMultiplierSelector)(state, merchandiseId);
  });
  var displayPriceTiers = priceTiers; // Need to create an artificial first tier in the prices
  // for included units on marketing contacts skus

  if (isMarketingContactsSku) {
    var includedTierUnits = includedAdditionalUnits / contactQuantityMuliplier;
    displayPriceTiers = priceTiers.map(function (_ref2) {
      var lowerBound = _ref2.lowerBound,
          upperBound = _ref2.upperBound,
          rest = (0, _objectWithoutProperties2.default)(_ref2, ["lowerBound", "upperBound"]);
      return Object.assign({}, rest, {
        lowerBound: lowerBound + includedTierUnits,
        upperBound: upperBound == null ? null : upperBound + includedTierUnits
      });
    }); // Annoyingly, only the first lower bound in price tiers is inclusive
    // so gotta make it exclusive when bumped up

    if (displayPriceTiers.length > 0) displayPriceTiers[0].lowerBound++;
    displayPriceTiers.unshift({
      lowerBound: 0,
      upperBound: includedTierUnits,
      value: 0
    });
  }

  var handleClickLink = function handleClickLink(source, href) {
    (0, _getUsageTracker.default)().track('externalLinkClick', {
      name: source,
      url: href
    });
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UITable.default, null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", {
    className: "text-left"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "contactConfirmation.contactTierPricingModal.contactsColumnHeader"
  })), _react.default.createElement("th", {
    className: "text-right"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "contactConfirmation.contactTierPricingModal.priceColumnHeader"
  })))), _react.default.createElement("tbody", null, displayPriceTiers.map(function (priceTier, index) {
    var upperBound = priceTier.upperBound,
        lowerBound = priceTier.lowerBound,
        value = priceTier.value;
    var lowerBoundToLastUpperBoundDiff = contactQuantityMuliplier - 1;
    var tierText;

    if (!lowerBound) {
      tierText = _react.default.createElement(_FormattedMessage.default, {
        message: "contactConfirmation.contactTierPricingModal.lowestTier",
        options: {
          value: upperBound * contactQuantityMuliplier
        }
      });
    } else if (!upperBound) {
      tierText = _react.default.createElement(_FormattedMessage.default, {
        message: "contactConfirmation.contactTierPricingModal.highestTier",
        options: {
          value: lowerBound * contactQuantityMuliplier - lowerBoundToLastUpperBoundDiff
        }
      });
    } else {
      tierText = _react.default.createElement(_FormattedMessage.default, {
        message: "contactConfirmation.contactTierPricingModal.middleTier",
        options: {
          lowerBound: lowerBound * contactQuantityMuliplier - lowerBoundToLastUpperBoundDiff,
          upperBound: upperBound * contactQuantityMuliplier
        }
      });
    }

    var priceText;

    if (!lowerBound) {
      priceText = _react.default.createElement(_FormattedCurrency.default, {
        value: value,
        currencyCode: currencyCode,
        simplifyCurrency: true
      });
    } else {
      priceText = _react.default.createElement(_FormattedJSXMessage.default, {
        message: "contactConfirmation.contactTierPricingModal.pricePerThousand_jsx",
        elements: {
          FormattedCurrency: _FormattedCurrency.default,
          FormattedNumber: _FormattedNumber.default
        },
        options: {
          value: value,
          thousand: contactQuantityMuliplier,
          currencyCode: currencyCode
        }
      });
    }

    return _react.default.createElement("tr", {
      key: index
    }, _react.default.createElement("td", {
      className: "text-left"
    }, tierText), _react.default.createElement("td", {
      className: "text-right"
    }, priceText));
  }))), isMarketingContactsSku && _react.default.createElement(_EmailSendsLimit.default, {
    marketingContactsSelected: marketingContactsSelected,
    emailSendsMultiplier: emailSendsMultiplier
  }), isMarketingContactsSku ? _react.default.createElement(_SubtextMC.default, {
    handleLinkClick: handleClickLink,
    merchandiseId: merchandiseId,
    termId: termId,
    edition: edition,
    priceTiers: priceTiers
  }) : _react.default.createElement(_ExampleSubtext.default, {
    priceTiers: priceTiers,
    currencyCode: currencyCode,
    handleClickLink: handleClickLink,
    merchandiseId: merchandiseId,
    termId: termId
  }));
};

var _default = PriceTiers;
exports.default = _default;
module.exports = exports.default;